/**
 * Series rename: `{n}` in the pattern is replaced by the zero-padded,
 * 1-based number; without `{n}` the number is appended. The original
 * file's extension is kept.
 */
export function seriesFilename(pattern: string, index: number, total: number, originalFilename: string): string {
  const digits = Math.max(2, String(total).length)
  const number = String(index + 1).padStart(digits, "0")
  const trimmed = pattern.trim()
  const base = trimmed.includes("{n}") ? trimmed.replaceAll("{n}", number) : `${trimmed} ${number}`
  const dot = originalFilename.lastIndexOf(".")
  const extension = dot > 0 ? originalFilename.substring(dot) : ""
  return base + extension
}
